module.exports = __webpack_public_path__ + "assets/retina_ShiftAngleDetailed.245ab8f54a0d174303bdbc5b2adbb710.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_ShiftAngleDetailed.png
// module id = 713
// module chunks = 0